export const admins = [
    'mrkobhrai@gmail.com',
    'docsoc@ic.ac.uk',
    'jaidityakhemani@gmail.com'
];

